import { render, staticRenderFns } from "./StatisticByRequests.vue?vue&type=template&id=11e0401a&scoped=true&"
import script from "./StatisticByRequests.vue?vue&type=script&lang=ts&"
export * from "./StatisticByRequests.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticByRequests.vue?vue&type=style&index=0&id=11e0401a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e0401a",
  null
  
)

export default component.exports